import { createContext, useContext } from 'react';
import type { ClusterDataContextType } from './types';
import { MeasurementRange } from '../../common/chart/types/types';
import { MeterTypeInternal } from '../../../api/openapi';

export const ClusterDataContext = createContext<ClusterDataContextType>({
  selectedRange: MeasurementRange.DayInHours,
  setSelectedRange: () => {},
  page: 0,
  setPage: () => {},
  fromTo: { from: new Date().toISOString(), to: new Date().toISOString() },
  meterType: MeterTypeInternal.Standalone,
  setMeterType: () => {},
  selectedInstallationIds: [],
  setSelectedInstallationIds: () => {},
});

export const useClusterDataContext = () => useContext(ClusterDataContext);
